import http from '../app/httpService';

const apiEndpoint = process.env.REACT_APP_MARKET_API+"periodicity/";

export async function getPeriodicities() {
    const {data: Periodicities} = await http.get(apiEndpoint);
    return Periodicities;
}
